export { default } from "./ContentBodyAnnotatedTextAnchor";
